import React, { useEffect, useRef } from 'react'
import { Loader } from '@googlemaps/js-api-loader'

import './Footer.css'

const Footer: React.FC = () => {
  const mapRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
      version: 'weekly',
    })
    loader
      .load()
      .then(() => {
        if (mapRef.current) {
          const map = new (window as any).google.maps.Map(mapRef.current, {
            center: { lat: 49.2499, lng: -123.1 },
            zoom: 17,
            styles: [
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }],
              },
            ],
          })

          map.addListener('click', () => {
            window.open(
              'https://www.google.com/maps/dir//4069+Main+St,+Vancouver,+BC+V5V+3P5/@49.2491666,-123.1838349,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x548673f9fd17200d:0x1e3280702936456!2m2!1d-123.1014566!2d49.249196?entry=ttu&g_ep=EgoyMDI1MDgwNi4wIKXMDSoASAFQAw%3D%3D',
              '_blank',
              'noopener',
            )
          })

          const geocoder = new (window as any).google.maps.Geocoder()
          const address = '4069 Main st, Vancouver, BC, V5V 3P5'

          geocoder.geocode({ address: address }, (results: any, status: any) => {
            if (status === 'OK' && results[0]) {
              const location = results[0].geometry.location

              map.setCenter(location)

              new (window as any).google.maps.Marker({
                position: location,
                map: map,
                title: 'Canadian Laundry - 4069 Main st, Vancouver, BC, V5V 3P5',
              })
            } else {
              console.error('Geocoding failed: ' + status)

              const fallbackLocation = { lat: 49.2499, lng: -123.1 }
              map.setCenter(fallbackLocation)
              new (window as any).google.maps.Marker({
                position: fallbackLocation,
                map: map,
                title: 'Canadian Laundry',
              })
            }
          })
        }
      })
      .catch(error => {
        console.error('Error loading Google Maps:', error)
      })
  })

  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div className='footer-left'>
          <div className='map-container' ref={mapRef}></div>
        </div>

        <div className='footer-right'>
          <div className='footer-section'>
            <h3>OPERATING HOURS:</h3>
            <div className='hours-table'>
            <div className='hours-row'>
                <span className='day'>Sunday</span>
                <span className='time'>8:30 am to 6:30 pm</span>
              </div>
              <div className='hours-row'>
                <span className='day'>Monday</span>
                <span className='time'>8:30 am to 6:30 pm</span>
              </div>
              <div className='hours-row'>
                <span className='day'>Tuesday</span>
                <span className='time'>8:30 am to 6:30 pm</span>
              </div>
              <div className='hours-row closed'>
                <span className='day'>Wednesday</span>
                <span className='time'>Closed</span>
              </div>
              <div className='hours-row'>
                <span className='day'>Thursday</span>
                <span className='time'>8:30 am to 6:30 pm</span>
              </div>
              <div className='hours-row'>
                <span className='day'>Friday</span>
                <span className='time'>8:30 am to 6:30 pm</span>
              </div>
              <div className='hours-row'>
                <span className='day'>Saturday</span>
                <span className='time'>8:30 am to 6:30 pm</span>
              </div>
              <div className='hours-row closed'>
                <span className='day'>Holiday</span>
                <span className='time'>Closed</span>
              </div>
            </div>
          </div>

          <div className='footer-section'>
            <h3>Location:</h3>
            <p>4069 Main st, Vancouver, BC, V5V 3P5</p>
            <p>Phone: (778) 956 – 1007</p>
            <p>Email: canlaundry1987@gmail.com</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
